/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./scene-view.vue?vue&type=template&id=74654532&scoped=true"
import script from "./scene-view.vue?vue&type=script&lang=js"
export * from "./scene-view.vue?vue&type=script&lang=js"
import style0 from "./scene-view.vue?vue&type=style&index=0&id=74654532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74654532",
  null
  
)

export default component.exports